'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * # 接口请求参数校验
 *
 * ```
 *  Ajax.request({
 *    url,
 *    method
 *    dataType,
 *    params,
 *    headers,
 *    callback
 *  })
 * ```
 */
exports.default = {
  url: _propTypes2.default.string.isRequired,
  method: _propTypes2.default.string,
  dataType: _propTypes2.default.string,
  params: _propTypes2.default.object,
  data: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array]),
  headers: _propTypes2.default.object,
  callback: _propTypes2.default.func
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/ajaxShape.js
// module id = 81
// module chunks = 0